module.exports = __webpack_public_path__ + "img/img-testimonial-logo-2@2x.525d9b2.png";